<div class="image-gallery" [class.image-gallery--disabled-pagination]="disablePagination">
  <div class="image-gallery__items" appSwiper [swiperOptions]="gallerySwiperOptions">
    <div class="swiper-wrapper" (click)="onSwiperClick()">
      @for (item of items; track item) {
        @if (isCityTripPlanner) {
          @if (item.imageUrl) {
            <section class="swiper-slide">
              <figure class="image-gallery__item image-gallery__item--trip-planner">
                <img loading="lazy" [ngSrc]="item.imageUrl" [fill]="true" alt="preview">

                <div class="image-gallery__item__row">
                  <h3 class="image-gallery__item__title">{{ item.name }}</h3>
                  <p class="image-gallery__item__description" [innerHtml]="item.shortDescription | safeHtml"></p>
                </div>
              </figure>
            </section>
          }
        } @else {
          @if (item.imageUrl) {
            <section class="swiper-slide">
              <figure class="image-gallery__item">
                <img loading="lazy" [ngSrc]="item.imageUrl" [fill]="true" alt="preview">
                <div class="image-gallery__item__header">
                  <h3 class="image-gallery__item__title">{{ item.name }}</h3>
                </div>
                <figcaption class="image-gallery__item__footer image-gallery__item__description"
                            [innerHtml]="item.shortDescription | safeHtml"
                ></figcaption>
              </figure>
            </section>
          }
        }
      }
    </div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button-next with-background"></div>
    <div class="swiper-button-prev with-background"></div>
  </div>

  @if (!isTripPlannerPage && !isCityPage) {
    <div class="image-gallery__thumbnails show-for-medium"
         appSwiper [swiperOptions]="thumbnailsSwiperOptions" #thumbnailsSwiper>
      <div class="swiper-wrapper">
        @for (item of items; track item) {
          @if (item.imageUrl) {
            <div class="swiper-slide">
              <div class="image-gallery__thumbnail">
                <img loading="lazy" [ngSrc]="item.imageUrl" width="45" height="45" alt="small preview">
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
